import { create, StateCreator } from 'zustand';
import { ManageDeliverySegmentedControlSelection } from '../components/DashboardManageDelivery';
import { DeliveryDashboardScreens } from '../models/model-enum';
import { DeliveryDashboardScreenNavigationSlice } from './store-model';
import { ACTION_NAVIGATION } from '../models/model-actions';
import { devtools } from 'zustand/middleware';
import { Statuses } from '../models/model-constants';
import { DASHBOARD_ORDER_FILTER_VALUES } from '../components/DashboardOrderList/components/DashboardOrderListFilter';

const createDeliveryDashboardScreenNavigationSlice: StateCreator<
  DeliveryDashboardScreenNavigationSlice,
  [['zustand/devtools', never]],
  [],
  DeliveryDashboardScreenNavigationSlice
> = (set) => ({
  bottomSheetForcedSnapHeight: null,
  activeCourierId: null,
  activeOrderHash: null,
  activeScreen: DeliveryDashboardScreens.MANAGE_DELIVERY_SCREEN,
  previousActiveScreen: DeliveryDashboardScreens.MANAGE_DELIVERY_SCREEN,
  activeManageDeliveryTab: ManageDeliverySegmentedControlSelection.COURIERS,
  activeOrderListFilter: DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED,
  activePostCodeFilterValues: [],
  isDataLoaded: null,
  unreadNewOrder: null,
  oldGoogleMapCleaned: false,
  setBottomSheetForcedSnapHeight: (height) => {
    set(
      () => ({ bottomSheetForcedSnapHeight: height }),
      false,
      ACTION_NAVIGATION.SET_FORCED_BOTTOMSHEET_SNAP_HEIGHT
    );
  },
  setOldGoogleMapCleaned: () => set(() => ({ oldGoogleMapCleaned: true })),
  setActiveOrderHash: (data) =>
    set(() => ({ activeOrderHash: data }), false, ACTION_NAVIGATION.SET_ORDER_HASH),
  setActiveCourierId: (data) =>
    set(() => ({ activeCourierId: data }), false, ACTION_NAVIGATION.SET_ACTIVE_COURIER),
  clearActiveCourier: () =>
    set(() => ({ activeCourierId: null }), false, ACTION_NAVIGATION.CLEAR_ACTIVE_COURIER),
  clearActiveOrder: () =>
    set(() => ({ activeOrderHash: null }), false, ACTION_NAVIGATION.CLEAR_ACTIVE_ORDER),
  clearUnreadNewOrders: () =>
    set(() => ({ unreadNewOrder: null }), false, ACTION_NAVIGATION.CLEAR_NEW_ORDER),
  setNewOrderReceived: () => {
    set(
      (state) => {
        const activeFilter = state.activeOrderListFilter;
        /* { unreadNewOrder: { ...state.unreadNewOrder, ...data } }), false, ACTION_NAVIGATION.SET_NEW_RECEIVED_ORDER) */
        return {
          unreadNewOrder:
            activeFilter !== DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED
              ? {
                  ...state.unreadNewOrder,
                  newOrderAmount: (state.unreadNewOrder?.newOrderAmount || 0) + 1,
                }
              : null,
        };
      },
      false,
      ACTION_NAVIGATION.SET_NEW_RECEIVED_ORDER
    );
  },
  setActiveScreen: (newScreen) =>
    set(
      (state) => ({ previousActiveScreen: state.activeScreen, activeScreen: newScreen }),
      false,
      ACTION_NAVIGATION.SET_ACTIVE_SCREEN
    ),
  setActiveManageDeliveryTab: (activeTab) =>
    set(
      () => ({ activeManageDeliveryTab: activeTab }),
      false,
      ACTION_NAVIGATION.SET_ACTIVE_MANAGE_DELIVERY_TAB
    ),
  setActivePostCodeFilterValues: (values) => {
    set(
      () => ({ activePostCodeFilterValues: values }),
      false,
      ACTION_NAVIGATION.SET_ACTIVE_POST_CODE_FILTER_VALUES
    );
  },
  setActiveOrderListFilter: (activeFilter) => {
    set(
      (state) => {
        if (activeFilter === DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED) {
          state.clearUnreadNewOrders();
        }

        return {
          activeOrderListFilter: activeFilter,
        };
      },
      false,
      ACTION_NAVIGATION.SET_ACTIVE_ORDER_LIST_FILTER
    );
  },

  setIsDataLoaded: (flag: boolean) =>
    set(() => ({ isDataLoaded: flag }), false, ACTION_NAVIGATION.SET_IS_DATA_LOADED),
});

export const useDashboardUIStore = create<DeliveryDashboardScreenNavigationSlice>()(
  devtools(
    (...a) => ({
      ...createDeliveryDashboardScreenNavigationSlice(...a),
    }),
    { name: 'UI', store: 'ui' }
  )
);
